module.exports = __webpack_public_path__ + "img/301.03570637.svg";